import { Theme, createStyles } from '@material-ui/core/styles';

export const styles = (theme: Theme) =>
    createStyles({
        root: {
            fontFamily: 'MuseoSans, sans-serif',
            width: '56.25%',
            marginTop: '200px',
            marginLeft: '30%',
            '& li': {
                marginBottom: '25px',
            },
            '& hr': { background: '#A2A5BD' },
            '& a': {
                color: '#3D4274',
                textDecoration: 'underline',
                textDecorationThickness: '2px',
                fontWeight: 800,
                whiteSpace: 'pre-wrap',
                wordWrap: 'break-word',
            },
            '& strong': { fontWeight: 800 },
            [theme.breakpoints.up(1441)]: {
                maxWidth: '810px',
                margin: '0 auto 580px auto',
                marginTop: '200px',
            },
            [theme.breakpoints.down(1200)]: {
                width: '75%',
                marginLeft: '22%',
            },
            [theme.breakpoints.down(900)]: {
                width: '78%',
                marginLeft: '22%',
            },
            [theme.breakpoints.down(510)]: {
                marginLeft: '21%',
            },
        },
        titleContainer: {
            marginRight: '9.3%',
            marginBottom: '154px',
            '& .title': {
                fontSize: '59.57px',
                fontWeight: 900,
                color: '#3D4274',
                letterSpacing: '7px',
                marginBottom: '0',
            },
            '& #sub': { marginLeft: '59.5px' },
            [theme.breakpoints.down(1000)]: {
                marginBottom: '65px',
                marginRight: '0',
                '& .title': {
                    fontSize: '55.24px',
                    letterSpacing: '6.34px',
                },
                '& #sub': { marginLeft: 0 },
            },
            [theme.breakpoints.down(701)]: {
                marginBottom: '100px',
                '& .title': {
                    fontSize: '52.24px',
                    letterSpacing: '6px',
                },
            },
            [theme.breakpoints.down(650)]: {
                marginBottom: '70px',
                '& .title': {
                    fontSize: '45px',
                    letterSpacing: '5.5px',
                },
            },
            [theme.breakpoints.down(501)]: {
                '& .title': {
                    fontSize: '29.85px',
                    letterSpacing: '3.43px',
                },
            },
        },
        bigDescription: {
            fontWeight: 400,
            fontSize: '32.2px',
            lineHeight: '38.64px',
            letterSpacing: '2px',
            marginBottom: '60px',
            color: '#3D4274',
            width: '80%',
            [theme.breakpoints.down(1000)]: {
                marginBottom: '50px',
                fontSize: '29.7px',
                letterSpacing: '2.13px',
            },
            [theme.breakpoints.down(701)]: {
                width: '100%',
                marginBottom: '70px',
                fontSize: '27.95px',
                letterSpacing: '2px',
            },
            [theme.breakpoints.down(501)]: {
                marginBottom: '55px',
                fontSize: '24px',
                letterSpacing: '1.2px',
            },
            [theme.breakpoints.down(400)]: {
                fontSize: '22.5px',
                letterSpacing: '0.5px',
            },
        },
        subSection: {
            marginBottom: '60px',
            fontWeight: 400,
            fontSize: '18.4px',
            lineHeight: '22.08px',
            letterSpacing: '0.55px',
            color: '#3D4975',
            width: '80%',
            '& .subtitle': { fontWeight: 800 },
            '& .embedded': {
                margin: '20px 0 40px 20px',
            },
            '& u': {
                cursor: 'pointer',
            },
            [theme.breakpoints.down(1000)]: {
                marginBottom: '50px',
                fontSize: '16px',
                lineHeight: '18px',
            },
            [theme.breakpoints.down(701)]: {
                width: '100%',
                marginBottom: '70px',
            },
            [theme.breakpoints.down(501)]: {
                marginBottom: '55px',
                fontSize: '14px',
                lineHeight: '16px',
            },
            [theme.breakpoints.down(400)]: {
                fontSize: '12px',
                lineHeight: '14px',
            },
        },
    });
